
import React from "react";
import { Row, Col, Card, Typography, Space } from "antd";
import {
  StockOutlined,
  ArrowUpOutlined,
  RiseOutlined,
  ArrowDownOutlined,
  FallOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const StockMetrics=({ data })=> {
  const totalItems = data.length;
  const inStockItems = data.filter((item) => item.stockStatus === "healthy").length;
  const lowStockItems = data.filter((item) => item.stockStatus === "low").length;
  const criticalStockItems = data.filter(
    (item) => item.stockStatus === "critical" || item.count < 0
  ).length;

  const metrics = [
    {
      title: "Total Items",
      value: totalItems,
      icon: StockOutlined,
      trend: "+12%",
      trendUp: true,
      description: "vs last month",
    },
    {
      title: "In Stock",
      value: inStockItems,
      icon: RiseOutlined ,
      trend: `${((inStockItems / totalItems) * 100).toFixed(0)}%`,
      trendUp: true,
      description: "of total inventory",
    },
    {
      title: "Low Stock",
      value: lowStockItems,
      icon: ExclamationCircleOutlined,
      trend: "-3%",
      trendUp: false,
      description: "needs attention",
      alert: true,
    },
    {
      title: "Critical",
      value: criticalStockItems,
      icon: FallOutlined,
      trend: criticalStockItems > 0 ? "Action required" : "All good",
      trendUp: false,
      description: "out of stock",
      critical: criticalStockItems > 0,
    },
  ];

  return (
    <Row gutter={[16, 16]} style={{marginTop:"10px"}}>
      {metrics.map((metric) => {
        const IconComponent = metric.icon;
        return (
          <Col xs={24} sm={12} md={12} lg={6} key={metric.title}>
            <Card bordered={true} style={{ borderRadius: "12px" }}>
              <Row justify="space-between" align="middle">
                <Col>
                  <Title level={5}>{metric.title}</Title>
                </Col>
                <Col>
                  <IconComponent
                    style={{
                      fontSize: 20,
                      color: metric.critical
                        ? "#ff4d4f"
                        : metric.alert
                        ? "#faad14"
                        : "#8c8c8c",
                    }}
                  />
                </Col>
              </Row>

              <div style={{ marginTop: 8 }}>
                <Title level={3}>{metric.value}</Title>
                <Space size="small">
                  <Text
                    strong
                    style={{
                      color: metric.trendUp
                        ? "#52c41a"
                        : metric.critical
                        ? "#ff4d4f"
                        : "#8c8c8c",
                    }}
                  >
                    {metric.trend}
                  </Text>
                  <Text type="secondary">{metric.description}</Text>
                </Space>
              </div>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
}
export default StockMetrics;